import styled from 'styled-components';
import { flexCenter, rowGap } from '../../styles/utils';

export const UrsModalLayout = styled.div<{ extra?: boolean }>`
  padding: 0 var(--padding-lg) var(--padding-lg);
  .phone-modal {
    padding-top: var(--padding-md);
  }
  .logo {
    height: 61px;
    margin-bottom: 30px;
    position: relative;
    z-index: 1;
    left: 50%;
    top: 10px;
    transform: translateX(-58%);
  }
  .yaotai-tips {
    text-align: center;
  }

  .urs-content,
  .divider,
  .third-login-wrapper {
    transform: translateY(20px);
  }

  .urs-content {
    height: 300px;
  }

  .divider {
    margin-bottom: 20px !important;
  }

  .third-login-wrapper {
    ${flexCenter()};
    ${rowGap('32px')};

    .third-logo {
      width: 40px;
      cursor: pointer;
    }
  }

  .extra-toolbar {
    position: relative;
    margin: 0 auto;
    cursor: pointer;
    color: var(--text-color-0);
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-lg);
    padding: var(--padding-lg) 20px 0;
    ${props =>
      props.extra &&
      `
      a{
        font-size: var(--font-size-lg);
        font-weight: normal;
      }`}
  }

  .modal-email-login {
    width: 380px;
    padding-top: var(--padding-md);
  }
`;
